document.addEventListener('DOMContentLoaded', () => {
  const productList = document.querySelector('#results');
  let isFetching = false;

  // ————————————————————————————
  // Infinite Scroll
  // ————————————————————————————

  const removePagination = () => {
    document.querySelectorAll('.pagination, .pagination li, .pagination a')
      .forEach(el => el.remove());
  };

  const sentinel = document.createElement('div');
  sentinel.id = 'infinite-scroll-sentinel';
  productList.parentElement.appendChild(sentinel);

  const loadNextPage = async () => {
    if (isFetching) return;

    const nextLink = document.querySelector('link[rel="next"]');
    if (!nextLink) {
      removePagination();
      observer.disconnect();
      return;
    }

    isFetching = true;

    const loader = document.createElement('div');
    loader.id = 'infinite-loader';
    loader.textContent = 'Loading more products...';
    loader.style.textAlign = 'center';
    productList.parentElement.insertBefore(loader, sentinel);

    try {
      const response = await fetch(nextLink.href, { cache: 'no-store' });
      if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newProducts = doc.querySelector('#results');

      if (newProducts) {
        productList.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }

      const newNextLink = doc.querySelector('link[rel="next"]');
      if (newNextLink) {
        nextLink.href = newNextLink.href;
      } else {
        nextLink.remove();
        removePagination();
        observer.disconnect();
      }
    } catch (error) {
      console.error('Error loading next page:', error);
    } finally {
      loader.remove();
      isFetching = false;
    }
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      loadNextPage();
    }
  }, { rootMargin: '200px' });

  observer.observe(sentinel);
  removePagination();

  // ————————————————————————————
  // Grid Switcher Init
  // — Uses retry loop because Alpine renders #grid-switcher after DOMContentLoaded
  // ————————————————————————————

  const initGridSwitcher = () => {
    const gridSwitcher = document.querySelector('#grid-switcher');
    if (!gridSwitcher) {
      setTimeout(initGridSwitcher, 100);
      return;
    }

    const validCols = ['3', '6', '9'];
    const saved = localStorage.getItem('gridCols');
    const targetCols = validCols.includes(saved) ? saved : '3';

    // Set the CSS variable on :root — CSS rule reads it, works on all products
    // including infinite scroll loaded ones, Alpine can't touch it
    const setGrid = (cols) => {
      document.documentElement.style.setProperty('--grid-switcher-cols', cols);
      gridSwitcher.querySelectorAll('.grid-switch').forEach(b => {
        b.classList.toggle('active', b.dataset.cols === String(cols));
      });
      localStorage.setItem('gridCols', cols);
    };

    setGrid(targetCols);

    // Re-apply when Alpine re-renders results after filter/sort
    const resultsEl = document.querySelector('#results');
    if (resultsEl) {
      new MutationObserver(() => {
        setGrid(localStorage.getItem('gridCols') || '3');
      }).observe(resultsEl, { childList: true, subtree: false });
    }

    gridSwitcher.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cols]');
      if (!btn) return;
      setGrid(btn.dataset.cols);
    });
  };

  initGridSwitcher();
});
